import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { postData } from "../../../backend/api";
import AutoForm from "../../elements/form";
import Footer from "../footer/index2";
import { FormContainer, MainContainer } from "./styles";
//using translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import withLayout from "../layout";
import { ColumnContainer } from "../../styles/containers/styles";
import Header from "../header";
import { clearLogin } from "../../../store/actions/login";
import { postData } from "../../../backend/api";
import { SignUpLink } from "../login/styles";
import LanguageTooltip from "../../elements/tooltip";

const LoginPageLink = ()=>{
  const { t } = useTranslation();
  return(
    <SignUpLink>
            {t('Already have an account?')} <Link style={{color:'#15629A'}} to="/">{t('Log in')}</Link>
          </SignUpLink>
  )
}

const Registration = (props) => {
  useEffect(() => {
    document.title = `Time Recording Tool`;
  }, []);

  const [activeStep, setActiveStep] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const { t } = useTranslation();
  const { setLoaderBox } = props;
  useEffect(() => {
    if (user.data?.token) {
      navigate("/dashboard");
    }
    // setLoaderBox(user.isLoading);
    if (user.error !== null) {
      props.setMessage({ type: 1, content: t(user.error), proceed: "Okay", code: 400 });
      dispatch(clearLogin());
    }
  }, [user, navigate, setLoaderBox, t, props, dispatch]);

  const [formInput1] = useState([
    {
      type: "select",
      placeholder: "select",
      name: "totalEmployees",
      validation: "",
      default: "",
      label: "howManyEmployees",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: "0 - 15", value: t("0 - 15") },
        { id: "15 - 30", value: t("15 - 30") },
        { id: "30 - 100", value: t("30 - 100") },
        { id: "100 - 500", value: t("100 - 500") },
        { id: "500 - 1000", value: t("500 - 1000") },
        { id: "1000+", value: t("1000+") },
      ],
      filter: false,
    },
    {
      type: "text",
      placeholder: "businessEmail",
      name: "email",
      validation: "email",
      default: "",
      label: "businessEmail",
      required: true,
      view: true,
      add: true,
      update: true,
    },
  ])

  const [formInput2] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "Your position",
      name: "position",
      validation: "",
      default: "",
      label: "Your position",
      required: true,
      view: true,
      add: true,
      update: true,
      customClass: "full",
      apiType: "JSON",
      selectApi: [
        { id: "CEO", value: t("CEO (Chief Executive Officer)") },
        { id: "HR Manager", value: t("HR Manager") },
        { id: "Admin/Operations Manager", value: t("Admin/Operations Manager") },
        { id: "Finance Manager/Accountant", value: t("Finance Manager/Accountant") },
        { id: "Department Manager", value: t("Department Manager") }
      ],
      filter: false,
    },
    {
      type: "text",
      placeholder: "Name of your Company",
      name: "companyName",
      validation: "",
      default: "",
      label: "Name of your Company",
      required: false,
      view: false,
      add: true,
      update: true,
      customClass: "full",
    },
    {
      type: "text",
      placeholder: "Company website",
      name: "companyWebsite",
      validation: "",
      default: "",
      label: "Company website",
      required: false,
      view: false,
      add: true,
      update: true,
      customClass: "full",
    },
    {
      type: "select",
      placeholder: "Industry",
      name: "industry",
      validation: "",
      default: "",
      label: "Industry",
      required: true,
      view: true,
      add: true,
      update: true,
      customClass: "full",
      apiType: "JSON",
      selectApi: [
        { id: "IT & Software Industry", value: t("IT & Software Industry") },
        { id: "Manufacturing Industry", value: t("Manufacturing Industry") },
        { id: "Retail & E-commerce Industry", value: t("Retail & E-commerce Industry") },
        { id: "Healthcare Industry", value: t("Healthcare Industry") },
        { id: "Hospitality Industry (Hotels & Restaurants)", value: t("Hospitality Industry (Hotels & Restaurants)") }
      ],
      filter: false,
    },
    {
      type: "number",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
      countryCode: true,
    },
    {
      type: "checkbox",
      placeholder: "acceptSignupSubmit",
      name: "acceptSignupSubmit",
      validation: "",
      showItem: "",
      default: "",
      label: "acceptSignupSubmit",
      required: true,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    
  ]);

  const [formData, setFormData] = useState({});

  const isCreatingHandler = (value, callback) => {};
  const submitChange = async (post) => {
    let payload = {...post, ...formData};
    delete payload.acceptSignupSubmit;
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...payload }, "company/signup")
      .then((response) => {
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t("enquiryFill"),
            okay: "Login",
            onClose: () => {
              navigate("/");
            },
            code: 200,
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };

  console.log(formData,activeStep);

  return (
    <MainContainer>
      {/* <Header> </Header> */}
      <ColumnContainer className="login signup">
        <FormContainer>
          {activeStep===1 ? <AutoForm key={"form"} useCaptcha={false} formType={"post"} description={t("signupdesc")} header={t("signup")} formInput={formInput1} submitHandler={(post)=> {
            setFormData(post)
            setActiveStep(2)
            }} button={t("next")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} login={"signupForm"} ></AutoForm>
          : <AutoForm key={"form"} useCaptcha={false} formType={"post"} description={t("Once you have submitted the form, you can immediately make an appointment to discuss your test account. You will also receive an e-mail with additional information.")} header={t("Almost there!")} formInput={formInput2} submitHandler={submitChange} button={t("send")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} login={"signupForm"} ></AutoForm>}
          <div style={{marginTop:'10px',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <LanguageTooltip page={"login"} />
          </div>
          <SignUpLink>
            {t('Already have an account?')} <Link style={{color:'#15629A'}} to="/">{t('Log in')}</Link>
          </SignUpLink>
        </FormContainer>
      </ColumnContainer>
      <Footer></Footer>
    </MainContainer>
  );
};

export default withLayout(Registration);
